var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"intro-info intro-info--security"},[_c('div',{staticClass:"container"},[_c('HeroTitle',{attrs:{"info":_vm.titleInfo}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }